<script lang="ts" setup>
defineProps({
  attributes: {
    default: () => [],
    type: Array as PropType<ApiAttribute[]>,
  },
  title: {
    default: undefined,
    type: String,
  },
})

const rootRef = ref<HTMLDivElement>()

function resetScrollPosition() {
  if (import.meta.client) {
    rootRef.value?.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: 0,
    })
  }
}

defineExpose({ resetScrollPosition })
</script>

<template>
  <ApiBox
    ref="rootRef"
    class="bg-texture shadow-texture flex flex-col overflow-y-auto rounded-lg ring-1 ring-gray-200 dark:text-gray-100 dark:ring-gray-800"
    :title="title"
  >
    <ApiAttribute
      v-for="(attribute, attributeIndex) in attributes"
      :key="attribute.name"
      :attributes="attribute.attributes"
      :description="attribute.description"
      :endpoint="attribute.endpoint"
      :example="attribute.example"
      :has-divider="attributeIndex !== attributes.length - 1"
      :has-segmentation="attribute.hasSegmentation"
      :link="attribute.link"
      :max-length="attribute.maxLength"
      :name="attribute.name"
      :optional="attribute.optional"
      :parent="attribute.parent"
      :required="attribute.required"
      :type="attribute.type"
      :values="attribute.values"
      :warning="attribute.warning"
    />
  </ApiBox>
</template>
